module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-400-vietnamese4.0925fd7.woff2";